import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useCalendarPanelStyles = makeStyles({
  /** Matches the toolbar button style used on the Rooms tab (todayButton). */
  filterButton: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding('0px', tokens.spacingHorizontalM),
    height: '32px',
    minHeight: '32px',
    maxHeight: '32px',
    minWidth: 'auto',
    fontSize: fontScale.body,
    lineHeight: '30px',
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    boxSizing: 'border-box' as const,
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  /** Applied when filters are active — blue bottom border indicator */
  filterButtonActive: {
    ...shorthands.borderBottom('2px', 'solid', tokens.colorBrandStroke1),
    color: tokens.colorBrandForeground1,
  },
});
